module.exports = __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge.aad343ac.png";